/**
 * 会社設定関連の定数
 */

// デフォルト陸送費（円）
export const DEFAULT_TRANSPORT_FEE = 30000;

// デモ会社ID（株式会社サンプル陸送）
export const DEMO_COMPANY_ID = 'e32a0499-6456-44ac-9b16-b0001098c259';

// デフォルト会社ID（ラクハイ管理のグローバルデータ）
export const DEFAULT_COMPANY_UUID = '00000000-0000-0000-0000-000000000000';

// 陸送費計算方法
export const TRANSPORT_FEE_CALCULATION_METHODS = {
  FIXED: 'fixed',
  DISTANCE_BASED: 'distance_based',
  VEHICLE_TYPE_BASED: 'vehicle_type_based',
} as const;
